// TODO: Тип у error явно не Error. Что тут за тип подразумевался?
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export default function getErrorNotification(error) {
  return ['notifications/create', {
    title: 'Ошибка',
    message: error?.detail ?? 'При выполнении запроса произошла ошибка',
  }, { root: true }];
}
